/**
 * Which agents have signed off on which items (agent_signoffs, migration 923)
 * — the source for the readiness criterion "agent sign-off". An agent signs
 * off on an item when a person accepts its output there.
 */

import { useEffect, useMemo, useState } from 'react';
import { loadAgentSignoffs } from '../lib/agentRuntimeService';
import { getCurrentWorkspaceId } from '../lib/supabaseSync';

export function useAgentSignoffs(itemIds: string[]): Record<string, Record<string, boolean>> {
  const workspaceId = getCurrentWorkspaceId();
  const key = useMemo(() => [...itemIds].sort().join(','), [itemIds]);
  const [signoffs, setSignoffs] = useState<Record<string, Record<string, boolean>>>({});
  useEffect(() => {
    if (!workspaceId || !key) { setSignoffs({}); return; }
    let cancelled = false;
    void loadAgentSignoffs(workspaceId, key.split(',')).then((m) => { if (!cancelled) setSignoffs(m); });
    return () => { cancelled = true; };
  }, [workspaceId, key]);
  return signoffs;
}
